import { CardProps } from '../../../models/card'
import './Card.scss'

const Card = (props: CardProps) => {
    const cardClass = 'card-box'
    const mobileClass = props.hideBorderOnMobile ? `${cardClass}--mobile-no-border` : ''
    const modeClass = `${cardClass}--${props.mode || 'default'}`
    const borderClass = props.borderLeftColor
        ? `${cardClass}--border ${cardClass}--border-${props.borderLeftColor}`
        : ''

    return (
        <div className={`${cardClass} ${modeClass} ${mobileClass} ${props.class}`}>
            {!!borderClass && <div className={borderClass} />}
            {props.children}
        </div>
    )
}

export default Card
